module.exports = __webpack_public_path__ + "static/media/sidebar.83eb8cab.png";